/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the StorefrontScanCreateBatchDTO interface.
 */
export function instanceOfStorefrontScanCreateBatchDTO(value) {
    return true;
}
export function StorefrontScanCreateBatchDTOFromJSON(json) {
    return StorefrontScanCreateBatchDTOFromJSONTyped(json, false);
}
export function StorefrontScanCreateBatchDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'urls': json['urls'] == null ? undefined : json['urls'],
    };
}
export function StorefrontScanCreateBatchDTOToJSON(json) {
    return StorefrontScanCreateBatchDTOToJSONTyped(json, false);
}
export function StorefrontScanCreateBatchDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'urls': value['urls'],
    };
}
